import { useEffect, useState } from 'react'

// The section whose top part sits in a band just under the sticky bar, or
// null above the first section. Keeps the last answer while the band falls in
// the gap between two sections, so the underline doesn't flicker.
export function useScrollSpy(ids: string[], offset: number): string | null {
  const [active, setActive] = useState<string | null>(null)

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return undefined

    const visible = new Set<string>()
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => (entry.isIntersecting ? visible.add(entry.target.id) : visible.delete(entry.target.id)))
        const first = document.getElementById(ids[0])
        const aboveAll = !first || first.getBoundingClientRect().top > offset
        setActive((previous) => ids.find((id) => visible.has(id)) ?? (aboveAll ? null : previous))
      },
      { rootMargin: `-${offset}px 0px -55% 0px` }
    )
    ids.forEach((id) => {
      const section = document.getElementById(id)
      if (section) observer.observe(section)
    })

    return () => observer.disconnect()
  }, [ids, offset])

  return active
}
